const license = {
  title: '申请许可',
  des: 'Apply for a licence',
  form: {
    des: '如果您对我们的产品感兴趣，可以提供您的信息申请产品试用',
    title: '基本信息',
    topic: {
      label: '主题',
      placeholder: '请选择',
      required: ['请选择']
    },
    serialNumber: {
      label: '序列号',
      placeholder: '请输入序列号',
      required: ['请输入序列号', '序列号错误']
    },
    institution: {
      label: '机构名称',
      placeholder: '请输入医院名称',
      required: ['请输入医院名称']
    },
    profession: {
      label: '职业',
      placeholder: '请选择',
      required: ['请选择职业']
    },
    surname: {
      label: '姓',
      placeholder: '请输入姓氏',
      required: ['请输入姓氏']
    },
    name: {
      label: '名',
      placeholder: '请输入名字',
      required: ['请输入名字']
    },
    country: {
      label: '国家',
      placeholder: '请选择',
      required: ['请选择国家']
    },
    address: {
      label: '地址',
      placeholder: '',
      required: ['']
    },
    province: {
      label: '',
      placeholder: '省',
      required: ['请选择省市']
    },
    city: {
      label: '',
      placeholder: '市',
      required: ['请选择市']
    },
    contactInformation: {
      title: '联系方式',
      telephone: '通过手机号码',
      email: '通过电子邮箱'
    },
    areaCode: {
      label: '请选择',
      placeholder: '请选择',
      required: ['请选择']
    },
    telephone: {
      label: '',
      placeholder: '请输入手机号码',
      required: ['请输入手机号', '无效的手机号']
    },
    email: {
      label: '邮箱',
      placeholder: '请输入邮箱',
      required: ['请输入邮箱', '邮箱格式错误']
    },
    invitationCode: {
      label: '',
      placeholder: '',
      required: []
    }
  },
  formData: {
    topic: {
      probation: '申请试用',
      code: '获取软件注册码'
    },
    profession: {
      physician: { name: '医师', value: '医师' },
      technician: { name: '医学技师', value: '医学技师' },
      scientificResearch: { name: '科研人员', value: '科研人员' },
      other: { name: '其他', value: '其他' }
    }
  },
  product: {
    title: '产品型号',
    warn: '(请先输入正确的序列号)',
    error: '请选择产品',
    skull: {
      title: '脑血管智能诊疗解决方案',
      bjImg: require('@/assets/images/license/skull_bj.png'),
      list: [
        { name: ['AneuFlow系列'], type: 'AneuFlow', img: require('@/assets/images/license/AneuFlow_Series.png') },
        { name: ['AneuGuide'], type: 'AneuGuide', img: require('@/assets/images/license/AneuGuide.png') },
        { name: ['AneuShape'], type: 'AneuShape', img: require('@/assets/images/license/AneuShape.png') },
        { name: ['AccuFFicas系列'], type: 'AccuFFicas', img: require('@/assets/images/license/AccuICAS.png') },
        { name: ['AneuPlan'], type: 'AneuPlan', img: require('@/assets/images/license/AneuPlan.png') },
        { name: ['AccuASPECTS'], type: 'AccuASPECTS', img: require('@/assets/images/license/AccuASPECTS.png') },
        { name: ['AccuCTP'], type: 'AccuCTP', img: require('@/assets/images/license/AccuCTP.png') }
      ]
    },
    heart: {
      title: '心血管智能诊疗解决方案',
      bjImg: require('@/assets/images/license/heart_bj.png'),
      list: [
        { name: ['AccuFFRct系列'], type: 'AccuFFRct', img: require('@/assets/images/license/AccuFFRct_Series.png') },
        { name: ['AccuFFRangio系列'], type: 'AccuFFRangio', img: require('@/assets/images/license/AccuFFRangio_Series.png') },
        { name: ['AccuFFRoct系列'], type: 'AccuFFRoct', img: require('@/assets/images/license/AccuFFRoct_Series.png') },
        { name: ['AccuFFRivus系列'], type: 'AccuFFRivus', img: require('@/assets/images/license/AccuFFRivus_Series.png') },
        { name: ['AccuLV'], type: 'AccuLV', img: require('@/assets/images/license/AccuLV.png') },
        { name: ['AccuIMR'], type: 'AccuIMR', img: require('@/assets/images/license/AccuIMR.png') }
      ]
    }
  },
  textarea: {
    title: '备注信息',
    placeholder: '请输入备注信息...'
  },
  checked: {
    text: ['我已阅读，理解并完全同意'],
    sign: '《脉流隐私政策》',
    tooltip: '您需要阅读并同意脉流隐私政策'
  },
  submit: '提交信息',
  submiting: '正在提交，请等待',
  results: {
    succ: ['感谢您联系脉流科技，您的信息已提交。', '我们将尽快与您联系！'],
    warn: ['您已超过提交次数上限，请勿重复提交 …'],
    err: ['提交失败，数据异常']
  },
  policy: {
    list: [
      ['1. 脉流隐私政策', '脉流科技有限公司尊重您的隐私权，我们承诺以负责任的方式使用与所有利益相关方有关的个人数据。为此，我们致力于遵守数据保护法律，我们的员工和供应商也遵守内部隐私的规则和政策。'],
      ['2. 关于本政策', '本隐私政策旨在向您介绍您通过我们的网站向我们进行线上咨询时，我们如何收集、使用、存储、分享和保护您的个人信息，以及您可以如何行使您的权利。请您在提交线上咨询和向我们提交任何个人信息前，仔细阅读并理解本隐私政策。您向我们点击“提交信息”进行线上咨询时，我们将会视为：', '（1） 您已经了解并同意了本隐私政策的内容，并且您同意脉流科技可以按照本隐私政策所述的方式收集、使用和共享您的个人信息；', '（2） 就您所知，您向我们提供的所有信息是真实和准确的。您提供的任何不准确信息，均可能会影响后续我们与您的联系与反馈。'],
      ['3. 数据保护的适用法律', '脉流科技设立于多个司法管辖区，不同国家的访客均可访问本网站。本政策旨在向个人信息主体提供有关个人信息的通知，以努力遵守脉流科技运营所在司法管辖区的所有数据保护法律中最严格的法律。作为个人信息处理者，，脉流科技将基于本隐私政策中所述的目的和方式处理个人信息。'],
      ['4. 处理个人信息的合法性', '在您使用“试用&激活”向我们提出问题和或意见建议时，您将被视为明确地给予我们您的许可（法律称之为“同意”），许可我们为向您提供答复之目的使用您提供的相关信息。当然，您可以随时撤回您的许可。', '如果脉流科技有法律或监管义务记录或披露在本网站上收集的信息，则处理个人信息的合法性则是脉流科技必须遵守的法律义务。'],
      ['5. 个人信息的收集', '（1）在您使用产品时，我们和我们的关联公司将出于以下目的处理您作为用户和产品持有人的个人数据，特别是联系方式和身份信息。', 'a) 向您提供软件、服务或信息;', 'b) 保护我们免受盗版和非法使用我们的软件或服务的侵害;', 'c) 根据使用情况改进我们的产品;', 'd) 用于我们的内部证据，以及为了保护我们和其他用户的权益;', 'e) 推广和营销我们的软件和服务;', 'f) 履行会计、税务和其他法律规定的法律义务。', '您可以随时反对出于a）至f）的目的处理您的个人数据。', '（2）出于上述目的，脉流科技可能会使用您的名字、姓氏、电子邮件、手机号、用户名、实际地址、IP地址、MAC地址等。'],
      ['6. 个人信息的安全', '为了保护您的隐私，脉流科技在处理您与我们共享的个人信息时，会采取网络安全措施以保护您个人信息的安全。这些必要的措施是技术性和组织性的，旨在防止更改、丢失和未经授权访问您的数据。'],
      ['7. 个人信息的共享', '未经您的许可，脉流科技不会与无关的第三方共享从本网站收集的您的个人信息。但是，在我们网站的正常运营中，我们会指示分包商代表我们处理个人信息。脉流科技和这些分包商实施适当的合同和其他措施来保护您的个人信息。特别是，分包商只能根据我们的书面规定来处理您的个人信息，他们必须实施技术性和组织性的安全措施来保护您的数据。'],
      ['8. 保留期限', '我们将根据获取个人信息的目的，并根据数据保护法律和良好的行为实践，在需要或允许的时间内保留您的个人信息。例如，我们可能会在与您建立关系的期间内以及在我们向您提供产品和服务期间存储和处理个人信息。 脉流科技可能会被要求在我们必须遵守的法律或监管义务的时间内将某些个人信息作为存档存储。到达数据保留期限后，脉流科技将删除并不再存储您的个人信息。'],
      ['9. 您对个人信息的权利', '在适用法律允许的范围内，作为个人信息主体，您可以随时请求查询、复制、更正、补充、删除您的个人信息，以及要求我们将您的部分个人信息转移给其他组织。在某些情况下，这些权利可能会受到限制，例如法律法规另有规定，或者我们可以证明我们具有其他合法性基础。如果您想行使您的权利，或提出有关您作为个人信息主体的权利的任何问题，请联系0571-88106256。'],
      ['10. 政策更新', '本政策可能会不时更新，以适应与个人信息相关的法律或监管变化，我们将指明政策的更新日期。我们将在本网站发布修订后的政策。任何更改将在修订后的政策发布后即刻生效。发生任何此类更改后，如您继续使用“申请许可”功能，将被视为您已接受所有此类更改。']
    ],
    date: '更新日期：2023年11月02日'
  }
}

export default license
